import React from 'react'
import moment from 'moment'

import { notifications } from '../../core/controllers/Notifications'
import { user } from '../../core/controllers/user';
import { userBilling } from '../../core/controllers/UserBilling';
import { browserHistory } from 'react-router'
import { billing } from '../../core/controllers/Billing'

import BillingAccountForm from '../../components/Billing/BillingAccountForm'
import BillingProfile from '../../components/Billing/BillingProfile'
import AccountReceivableForm from '../../components/Billing/AccountReceivableForm'
import NavLink from '../../components/Routes/NavLink';
import CreditCardCard from '../../helpers/Cards/CreditCardCard';
import { TabGroup } from '../../helpers/Tabs/TabGroup';
import { Tab } from '../../helpers/Tabs/Tab';

export default class BillingTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            billingSetup: false,
            customerSplashMerchant: null,
            accountReceivableSetup: false,
            updateBilling: false,
            startEditing: false,
            overviewActive: 'active',
            profileActive: '',
            editProfile: false,
            billingProfile: null,
            didSetupProfile: false,
            billingApproved: false,
            noBankAccounts: true,
            banks: [],
            cards: []
        };
    }

    componentDidMount() {
        var self = this;
        billing.getProfile(function(response) {
            if (response) {
                var noBankAccounts = true;
                var billingApproved = false;
                if (response.data.banks.length > 0) {
                    noBankAccounts = false;
                }
                if(response.data.can_process_payments == 1){
                    billingApproved = true;
                }
                self.setState({
                    billingProfile: response.data.profile,
                    banks: response.data.banks,
                    cards: response.data.cards,
                    didSetupProfile: true,
                    noBankAccounts: noBankAccounts,
                    billingApproved: billingApproved
                });
            }
        });
    }

    editBilling() {
        this.setState({
            updateBilling: this.state.updateBilling ? false : true
        });
    }

    startEditing() {
        this.setState({
            startEditing: true
        });
    }

    finishedForm() {
        var self = this;
        billing.getProfile(function(response) {
            if (response) {
                var noBankAccounts = true;
                var billingApproved = false;
                if (response.data.banks.length > 0) {
                    noBankAccounts = false;
                }
                if(response.data.can_process_payments == 1){
                    billingApproved = true;
                }
                self.setState({
                    billingProfile: response.data.profile,
                    banks: response.data.banks,
                    didSetupProfile: true,
                    billingApproved: billingApproved,
                    noBankAccounts: noBankAccounts,
                    startEditing: false,
                    overviewActive: 'active',
                    profileActive: '',
                    editProfile: false
                });
            }
        });
    }

    editProfile() {
        this.setState({
            editProfile: true,
            profileActive: 'active',
            overviewActive: ''
        });
    }

    handleTabChange(type) {
        if(type == 'overview') {
            this.setState({
                overviewActive: 'active',
                profileActive: '',
                editProfile: false
            });
        } else if (type == 'profile') {
            this.setState({
                overviewActive: '',
                profileActive: 'active',
                editProfile: true
            });
        }
    }


    render(){
        const startEditing      = this.state.startEditing;
        const profileActive     = this.state.profileActive;
        const overviewActive    = this.state.overviewActive;
        const editProfile       = this.state.editProfile;
        const didSetupProfile   = this.state.didSetupProfile;
        const noBankAccounts    = this.state.noBankAccounts;
        const billingProfile    = this.state.billingProfile;
        const billingApproved   = this.state.billingApproved;
        const banks             = this.state.banks;
        const cards             = this.state.cards;
        const userType          = user.userInfo != null ? user.userInfo.user_type_alias : 'admin';
        const showAddCreditCard = userType == 'admin' ||
            userType == 'tenant';

        var title               = 'Payment Collection';
        if(user.userInfo && user.userInfo.user_type_alias == 'tenant') {
            title               = 'Payment Management'
        }

        var account4            = 'XXXXXXXX-';

        const cardsHTML         = cards.map((card, index) => {
            return(
                <CreditCardCard
                    key={index}
                    id={card.id}
                    fingerprint={card.fingerprint}
                    cardName={card.cardName}
                    isDefault={card.default}
                    lastFour={card.last4}
                    issuer={card.brand}
                    cardStatus={card.checks}
                />
            )
        });

        const bankCardsHTML    = banks.map((bank, index) => {
            return (
                <div class="col-md-3 col-sm-6 col-xs-12" key={index}>
                    <NavLink to={"/account/billing/" + bank.id}>
                    <div class="info-box">
                        <span class="info-box-icon blue-icon-circle"><i class="icon-bank"></i></span>
                        <div class="info-box-content">
                            <span class="info-box-text">
                            {bank.accountName}
                            { bank.default && (
                                <small class="green"> primary</small>
                            )}
                            </span>
                            <br/>
                            <span class="info-box-subtext bank-info">
                                <small>Routing:</small> {bank.routing}
                            </span>
                            <br/>
                            <span class="info-box-subtext bank-info">
                                <small>Account:</small> {account4}{bank.account}
                            </span>
                            <br/>
                            <span class="info-box-subtext bank-info">
                                <small>Status:</small>&nbsp;
                                { bank.status == 'PENDING' ? (
                                    <span class="red-info-number">
                                    {bank.status}
                                    </span>
                                ) : (
                                    <span class="green">
                                    {bank.status}
                                    </span>
                                )}
                            </span>
                        </div>
                    </div>
                    </NavLink>
                </div>
            )
        });

        return (
            <div class="col-md-12">
                <div class="row">
                    {(user.userInfo && user.userInfo.user_type_alias == 'tenant') && (
                    <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                    )}
                    <div class="main-page-header-row container-fluid col-md-12">
                        <div class="col-md-5">
                            <span class="main-page-header-title">{title}</span>
                        </div>
                        <div class="pull-right" style={{paddingTop: "7px"}}>

                            { didSetupProfile == true && billingApproved == true && (
                                <NavLink to={"/account/billing/new"}>
                                    <button type="button" style={{marginBottom: "7px"}} id="add-transaction" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" onClick="">
                                        Add Bank Account
                                    </button>
                                </NavLink>
                            )}
                            { didSetupProfile == true && showAddCreditCard && billingApproved == true && (
                                <NavLink to={"/account/billing/cc/new"}>
                                    <button type="button" id="add-transaction" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" onClick="">
                                        Add Credit Card
                                    </button>
                                </NavLink>
                            )}
                        </div>
                    </div>
                </div>
                <TabGroup
                    indexOverride={editProfile && 1}
                    noteActiveTab={() => this.setState({editProfile: false})}
                >
                    <Tab title="overview" key={0}>
                        { didSetupProfile == false && startEditing === false && (
                            <div>
                                <div style={{textAlign: "center"}}>
                                    <div class="row">
                                        <br/>
                                        <div class="main-page-header-row col-md-12">
                                            <div class="row">
                                                <span class="main-page-header-title">Setup Billing Profile</span>
                                            </div>
                                            <div class="row" style={{marginTop: "10px"}}>
                                                <button type="button" data-loading-text="Loading..." class="btn btn-info btn-fill pull-center" autoComplete="off" onClick={this.editProfile.bind(this)}>
                                                    Setup Profile
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12" style={{backgroundImage: "url('/assets/img/payment.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'top', backgroundSize: 'contain', minHeight: '565px'}}></div>
                            </div>
                        )}
                        { didSetupProfile == true && noBankAccounts == true && cards.length == 0 && billingApproved == true &&  (
                            <div>
                                <div style={{textAlign: "center"}}>
                                    <div class="row">
                                        <br/>
                                        <div class="main-page-header-row col-md-12">
                                            <div class="row">
                                                <span class="main-page-header-title">Link a Bank Account</span>
                                            </div>
                                            <div class="row" style={{marginTop: "10px"}}>
                                                <NavLink to={"/account/billing/new"}>
                                                    <button type="button" data-loading-text="Loading..." class="btn btn-info btn-fill pull-center" autoComplete="off" onClick={this.editProfile.bind(this)}>
                                                        Add Bank
                                                    </button>
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12" style={{backgroundImage: "url('/assets/img/payment.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'top', backgroundSize: 'contain', minHeight: '565px'}}></div>
                            </div>
                        )}
                        { didSetupProfile == true && (noBankAccounts == false || cards.length > 0) && (
                            <div class="row">
                                {cardsHTML}
                                {bankCardsHTML}
                            </div>
                        )}
                        { didSetupProfile == true && billingApproved === false && (
                            <div>
                                <div style={{textAlign: "center"}}>
                                    <div class="row">
                                        <br/>
                                        <div class="main-page-header-row col-md-12">
                                            <div class="row">
                                                <span class="main-page-header-title">Account in review</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12" style={{backgroundImage: "url('/assets/img/payment.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'top', backgroundSize: 'contain', minHeight: '565px'}}></div>
                            </div>
                        )}
                    </Tab >
                    <Tab title="billing profile" key={1}>
                        <div>
                            <div class="row">
                                <div class="sub-page-header-row col-md-11">
                                    <div class="row">
                                        <span class="sub-page-header-title"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="header">
                                    <h4 class="title"></h4>
                                    <p class="category"></p>
                                </div>
                                <div class="content">
                                    <BillingProfile billingProfile={billingProfile} finishedForm={this.finishedForm.bind(this)}/>
                                </div>
                            </div>
                        </div>
                    </Tab>
                </TabGroup>
                <br/>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Billing/Billing.jsx